const routes = [{
  path: '/feiche/order',
  component: () => import('@/views/feiche/order'),
  name: 'feiche-order',
  meta: {
    title: '个险订单'
  }
}, {
  path: '/feiche/task',
  component: () => import('@/views/feiche/task'),
  name: 'feiche-task',
  meta: {
    title: '订单管理/任务列表'
  }
}, {
  path: '/feiche/orderParticulars',
  component: () => import('@/views/feiche/orderParticulars'),
  name: 'feiche-orderParticulars',
  meta: {
    title: '订单详情'
  }
}, {
  path: '/feiche/orderEdit',
  component: () => import('@/views/feiche/orderEdit'),
  name: 'feiche-orderEdit',
  meta: {
    title: '订单编辑'
  }
}, {
  path: '/feiche/orderBatch',
  component: () => import('@/views/feiche/orderBatch'),
  name: 'feiche-orderBatch',
  meta: {
    title: '订单批改'
  }
}, {
  path: '/feiche/store',
  component: () => import('@/views/feiche/store/order'),
  name: 'feiche-store',
  meta: {
    title: '分销订单'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/order.js